import classNames from "classnames";
import {
  GOVGR_DATE_INPUT__ITEM,
  GOVGR_ERROR_INPUT,
  GOVGR_INPUT,
  GOVGR_INPUT__WIDTH_3,
  GOVGR_LABEL,
} from "../../conf/styles/GovGrDate";

const Input = ({
  label,
  name,
  autoComplete,
  form,
  field,
  value,
  handleChange,
  disabled,
  isErrorAndTouched,
  ...rest
}) => {
  const inputClassName = classNames(`${GOVGR_INPUT}`, GOVGR_INPUT__WIDTH_3, {
    [GOVGR_ERROR_INPUT]: isErrorAndTouched && form.errors[field.name],
  });

  return (
    <div className={GOVGR_DATE_INPUT__ITEM}>
      <label className={GOVGR_LABEL}>
        {label}
        <input
          className={inputClassName}
          value={value}
          onChange={handleChange}
          onBlur={() =>
            form.setTouched({
              ...form.touched,
              [field.name]: true,
            })
          }
          type="text"
          pattern="0[1-9]|1[0-2]"
          inputMode="numeric"
          name={name}
          autoComplete={autoComplete}
          disabled={!!disabled}
          readOnly={!!disabled}
          {...rest}
        />
      </label>
    </div>
  );
};

export default Input;
